<template>
  <div style="margin-top: 20px">
    <div
      style="
        display: flex;
        font-size: 28px;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid black;
        background-color: #f7f7f7;
      "
    >
      <div :class="getDetailActive == 1 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        >
          招采公告
        </div>
      </div>
      <div :class="getDetailActive == 2 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        >
          收费标准
        </div>
      </div>
    </div>
    <div
      style="
        text-align: center;
        padding: 20px;
        padding-top: 40px;
        font-size: 24px;
      "
      class="conent"
    >
      <div v-show="getDetailActive == 1">
        <div>
          <div class="fengexian">
            <el-divider content-position="center">招采公告</el-divider>
          </div>
        </div>
        <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.deptName + projectDetail.projectname }}
          </p>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            采购公告
          </p>
          <p style="text-indent: 2em">
            根据采购人申请，定于{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.biddingStartTime
            }}在获嘉县农村产权交易中心网络竞价平台对{{
              projectDetail.projectname
            }}进行公开竞价采购，现将采购事项公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 700">一、项目基本情况</p>
          <p style="text-indent: 2em">
            1、项目编号：{{ projectDetail.numbering }}
          </p>
          <p style="text-indent: 2em">
            2、项目名称：{{
              projectDetail.deptName + projectDetail.projectname
            }}
          </p>
          <p style="text-indent: 2em">3、采购方式：网络竞价（反向）采购</p>
          <p style="text-indent: 2em">
            4、预算总额：{{ projectDetail.price }}元（最高限价）
          </p>
          <p style="text-indent: 2em">
            5、项目地址：{{ projectDetail.address }}
          </p>
          <p style="text-indent: 2em">6、标段划分：本项目共划分为一个标段</p>
          <p style="text-indent: 2em">
            7、质量标准：合格、达到国家质量验收标准
          </p>
          <p style="text-indent: 2em">
            8、合同期限：合同签订后{{ getYearLimit() }}年
          </p>
          <p style="text-indent: 2em">9、资金来源：自筹资金</p>
          <p style="text-indent: 2em">
            10、付款方式：施工结束后，经验收合格，安装施工方开具正规发票后，一次性结清
          </p>
          <p style="text-indent: 2em">11、履约保证金：无</p>
          <p style="text-indent: 2em">12、项目是否接受联合体：否</p>
          <p style="text-indent: 2em">
            13、采购需求：供应商按照{{
              projectDetail.deptName + projectDetail.projectname
            }}采购清单内容采购施工
          </p>
          <p style="text-indent: 2em; font-weight: 700">二、供应商的资格要求</p>
          <p style="text-indent: 2em">
            1、需具有有效的营业执照，有相应的经营范围。
          </p>
          <p style="text-indent: 2em">2、具有独立承担民事责任的能力。</p>
          <p style="text-indent: 2em">3、具有良好的商业信誉。</p>
          <p style="text-indent: 2em">
            4、具有履行合同所必需的设备和专业技术能力。
          </p>
          <p style="text-indent: 2em">5、有依法缴纳税收的良好记录。</p>
          <p style="text-indent: 2em">
            6、信誉要求：列入失信被执行人、重大税收违法失信主体、政府采购严重违法失信行为记录名单的供应商，将拒绝参与本次采购活动。【查询渠道：1.“信用中国”网站（www.creditchina.gov.cn）查询内容:重大税收违法失信主体；2.“中国执行信息公开网”网站(http://zxgk.court.gov.cn)查询内容为：失信被执行人；3.中国政府采购网（www.ccgp.gov.cn）查询内容为：政府采购严重违法失信行为记录名单】。
          </p>
          <p style="text-indent: 2em">
            7、其他要求：供应商负责人为同一人或者存在控股、管理关系的不同单位，不得参加同一招标项目投标（提供“国家企业信用信息公示系统”中公示的公司信息、股东或投资人信息截图）。
          </p>
          <p style="text-indent: 2em; font-weight: 700">三、报名方式</p>
          <p style="text-indent: 2em">
            1、报名时间：{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.applyStartTime
            }}至{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.applyStopTime
            }}。
          </p>
          <p style="text-indent: 2em">2、报名注意事项：</p>
          <p style="text-indent: 2em">
            2.1意向供应商须在{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.applyStartTime
            }}前登录获嘉县农村产权交易中心官网，按要求进行实名注册及报名。
          </p>
          <p style="text-indent: 2em">
            2.2意向供应商需在{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.applyStartTime
            }}前按要求上传相关资料进行资格审核。
          </p>
          <p style="text-indent: 2em; font-weight: 700">四、采购保证金</p>
          <p style="text-indent: 2em">
            1、采购保证金金额：{{
              projectDetail.bailAmount
            }}元人民币（大写：人民币{{
              bigWrite(projectDetail.bailAmount)
            }}整）。
          </p>
          <p style="text-indent: 2em">
            2、采购保证金到账截止时间：{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.applyStartTime
            }}（北京时间）。
          </p>
          <p style="text-indent: 2em">3、保证金交纳账户：</p>
          <p style="text-indent: 2em">户名：{{ backCardInfo.cardName }}</p>
          <p style="text-indent: 2em">开户行：{{ backCardInfo.bankName }}</p>
          <p style="text-indent: 2em">账户：{{ backCardInfo.cardNo }}</p>
          <p style="text-indent: 2em">
            注：采购保证金未在规定时间到账、未交纳到指定账号或无效交纳的，该意向供应商不能参与竞价。汇款时请注明该笔费用为保证金，并备注项目名称或项目编号（须为供应商账户汇出）。
          </p>
          <p style="text-indent: 2em">五、采购竞价</p>
          <p style="text-indent: 2em">
            1、竞价开始时间：{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.biddingStartTime
            }}（北京时间）。
          </p>
          <p style="text-indent: 2em">2、竞价方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            3、自由竞价时间：{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.biddingStartTime
            }}至{{
              projectDetail.releaseRecord &&
              projectDetail.releaseRecord.biddingStopTime
            }}。
          </p>
          <p style="text-indent: 2em">
            4、限时竞价周期：180秒（注：请意向供应商在竞价开始前10分钟登录竞价大厅，以免因其他原因造成无法进入竞价大厅。）
          </p>
          <p style="text-indent: 2em; font-weight: 700">六、确定成交供应商：</p>
          <p style="text-indent: 2em">
            1、采购人按照报价最低原则确定成交供应商。如只有一家意向供应商参与报价且其报价没有超过采购预算，采购人即可将其确定为成交供应商。
          </p>
          <p style="text-indent: 2em">
            2、报价最低的供应商放弃成交的，其交纳的采购保证金不予退还并作为违约金由农交中心予以没收。对意向供应商失信行为的惩戒措施按相关法律法规及获嘉县农村产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 700">七、声明：</p>
          <p style="text-indent: 2em">
            进入网络竞价环节且出价的意向供应商即视为完全同意并响应采购公告、采购文件的全部内容，成交之后不得再以此为由提出任何异议。成交供应商所供的标的及服务（工程服务）必须实质性满足采购公告、采购文件的全部需求，若不满足上述要求，其采购保证金将不予退还并作为违约金由农交中心予以没收。意向供应商所提供的标的及服务（工程服务）若未按采购公告、采购文件要求或未完全满足采购公告、采购文件要求的，将会列入农交中心诚信评价体系。对意向供应商失信行为的惩戒措施按相关法律法规及获嘉县农村产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 700">八、发布公告的媒介</p>
          <p style="text-indent: 2em">
            本次采购公告在获嘉县农村产权交易中心官网上发布。
          </p>
          <p style="text-indent: 2em; font-weight: 700">九、联系方式</p>
          <p style="text-indent: 2em">采购人：{{ projectDetail.needname }}</p>
          <p style="text-indent: 2em">地址：{{ projectDetail.areaName }}</p>
          <p style="text-indent: 2em">联系人：{{ projectDetail.needname }}</p>
          <p style="text-indent: 2em">
            联系电话：{{ realPhone || projectDetail.phone }}
            <img
              src="../assets/img/openEye.png"
              style="width: 30px; height: 30px; cursor: pointer"
              @click="checkShowPhone"
            />
          </p>
          <p style="text-indent: 2em">组织机构：获嘉县农村产权交易中心</p>
        </div>
      </div>
      <div v-show="getDetailActive == 2">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">收费标准</el-divider>
          </div>
        </div>
        <div
          style="text-align: left; display: block"
          v-html="chargeStandard"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhoneById } from '../api/login'
import { getNewsDetail, getNewslist } from '../api/mian'
import { getProList } from '../api/交易项目'
import { getInfoByDeptId } from '../api/交易项目详情'
import { cityDetail } from '../util/mainOption'

export default {
  props: {
    projectDetail: {
      type: Object,
      default: () => { return {} }
    },
    dicts: {
      type: Object,
      default: () => { return {} }
    },
    backCardInfo: {
      type: Object,
      default: () => { return {} }
    },
    timeDetail: {
      type: Object,
      default: () => { return {} }
    },
    isLogin: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      // 当前地级名称
      deptName: '',
      // 查看区域下标
      getDetailActive: '1',
      showPhone: false,
      // 小分类列表
      classTypeList: [],
      // 报名方式 html
      applyWay: "",
      // 报名须知 html
      bmxzContent: "",
      // 竞拍须知 html
      jpxzContent: "",
      // 收费标准
      chargeStandard: "",
      realPhone: "",
    }
  },
  mounted () {
    this.deptName = localStorage.getItem('deptName')
      ? localStorage.getItem('deptName')
      : this.cityDetail.cityName
    getNewslist({
      number: '020',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        console.log("收费标准新闻详情", res.data.data)
        this.chargeStandard = res.data.data.content
      })
    })
    getNewslist({
      number: '021',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.applyWay = res.data.data.content
      })
    })
    getNewslist({
      number: '022',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.bmxzContent = res.data.data.content
        console.log("报名须知新闻详情", this.bmxzContent)
      })
    })
    getNewslist({
      number: '023',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.jpxzContent = res.data.data.content
        console.log("竞拍须知新闻详情", this.jpxzContent)
      })
    })
    getProList({ type: 3 }).then((res) => {
      // console.log('已打印')
      this.classTypeList = res.data.data
    })
  },
  methods: {
    // 手机号小眼睛点击事件
    checkShowPhone () {
      if (this.realPhone) return
      if (!localStorage.getItem('token')) {
        this.$message.warning("请登录后查看！")
        return
      }
      getPhoneById({
        id: this.projectDetail.id,
        projectType: 3
      }).then(res => {
        if (res.data.code == 200) {
          this.realPhone = res.data.msg
        }
      })
    },
    getYearLimit () {
      let start = new Date(this.projectDetail.needstarttime)
      let stop = new Date(this.projectDetail.needstoptime)
      return (
        (Number(stop.getTime()) - Number(start.getTime())) /
        (1000 * 60 * 60 * 24 * 30 * 12)
      ).toFixed(1)
    },
    // 获取小分类列表
    getClassList (list, id) {
      return list.filter((item) => {
        return item.code == id
      })[0]
        ? list.filter((item) => {
          return item.code == id
        })[0].name
        : ''
    },
    // 获取字典内容方法
    getDictsVal (list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
            return item.dictValue == val
          })[0].dictLabel
          : ''
      }
      return ''
    },
    bigWrite (num) {
      let max = 999999999999.99
      if (Number(num) > max) return "超过函数可接受最大值"
      let unitList = [
        "",
        "拾",
        "佰",
        "仟",
      ]
      let numberList = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖",
      ]
      let decimals = num.toString().split(".")[1]
      num = num.toString().split(".")[0]
      let numToStringRes = ""
      let numSliceList =
        console.log("num.length", num.length)
      if (num.length > 8) {
        numSliceList = {
          "亿": "",
          "万": "",
          "元": "",
        }
        numSliceList["亿"] = num.slice(0, num.length - 8)
        numSliceList["万"] = num.slice(num.length - 8, num.length - 4)
        numSliceList["元"] = num.slice(num.length - 4)
      } else if (num.length > 4) {
        numSliceList = {
          "万": "",
          "元": "",
        }
        numSliceList["万"] = num.slice(0, num.length - 4)
        numSliceList["元"] = num.slice(num.length - 4)
      } else {
        numSliceList = {
          "元": "",
        }
        numSliceList["元"] = num
      }
      for (let j = 0; j < Object.keys(numSliceList).length; j++) {
        num = Number(numSliceList[Object.keys(numSliceList)[j]])
        let stringRes = ""
        for (let i = 0; i < unitList.length; i++) {
          if (num == 0) {
            break
          }
          let yu = Math.floor(num % 10)
          stringRes = (numberList[yu] == "零" ? numberList[yu] : (numberList[yu] + unitList[i])) + stringRes
          num = Math.floor(num / 10)
        }
        while (true) {
          if (stringRes.indexOf("零零") < 0) {
            break
          }

          stringRes = stringRes.replace("零零", "零")
        }
        if (stringRes.slice(stringRes.length - 1) == "零") {
          stringRes = stringRes.substring(0, stringRes.length - 1)
        }
        stringRes += Object.keys(numSliceList)[j]
        numToStringRes += stringRes
      }
      if (decimals.length > 0 && Number(decimals) != 0) {
        decimals = Number(decimals)
        numToStringRes += (numberList[Math.floor(decimals / 10)] ? numberList[Math.floor(decimals / 10)] + "角" : "零") + (numberList[Math.floor(Number(decimals % 10))] == "零" ? numberList[Math.floor(Number(decimals % 10))] + "分" : "")
      }
      while (true) {
        if (numToStringRes.indexOf("壹拾") < 0) {
          break
        }
        numToStringRes = numToStringRes.replace("壹拾", "拾")
      }
      return numToStringRes
    },
  },
}
</script>

<style lang="scss" scoped>
.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
  cursor: pointer;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
  cursor: pointer;
}
.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
  cursor: pointer;
}

.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
}

.tet2 {
  padding: 20px 20px;
  width: 550px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100%; */
}

.money {
  display: flex;
  flex-direction: column;
}

.moneyTableTitle {
  display: flex;
  align-content: center;
}

.mtt {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
  font-weight: 600;
  background-color: #f3f5f8;
}

.mtc {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
}

.list {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #606266;
  padding: 10px 0;
  border-bottom: 1px solid #606266;
  display: flex;
  justify-content: space-between;
}

.list:last-child {
  border-bottom: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}

.input-number {
  /* transform: scale(1.25); */
  width: 200px;
}

.input-number >>> .el-input__inner {
  width: 200px;
  text-align: right;
  font-size: 24px !important;
  font-weight: bold !important;
}
.conent > div {
  margin: 10px 0;
}
.fengexian {
  margin-bottom: 40px;
  /deep/ .el-divider__text {
    font-size: 36px;
    /* margin-bottom: 40px; */
    color: #f56c6c;
    list-style: armenian;
  }
}

.fengexian1 {
  margin: 30px 0 50px 0;
  /deep/ .el-divider__text {
    font-size: 36px;
    /* margin-bottom: 40px; */
    color: #f56c6c;
    list-style: armenian;
  }
}
.hetongBox {
  width: 100%;
  height: auto;
  text-align: start;
  p {
    line-height: 2;
  }
}
</style>